import { Eye, EyeOff, TextCursor } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Timer } from "./Timer";

interface WritingControlsProps {
  showWordCount: boolean;
  setShowWordCount: (show: boolean) => void;
  showTimer: boolean;
  setShowTimer: (show: boolean) => void;
  wordCount: number;
  isEvaluated?: boolean;
}

export const WritingControls = ({
  showWordCount,
  setShowWordCount,
  showTimer,
  setShowTimer,
  wordCount,
  isEvaluated,
}: WritingControlsProps) => {
  if (isEvaluated) {
    return null;
  }

  return (
    <div className="flex items-center gap-8 p-4">
      <Timer showTimer={showTimer} onShowTimerChange={setShowTimer} />

      <div className="flex items-center gap-2">
        <Button
          variant="link"
          size="icon"
          onClick={() => setShowWordCount(!showWordCount)}
          className="h-4 w-4 p-0"
        >
          {showWordCount ? (
            <Eye className="h-4 w-4 text-orange-500" />
          ) : (
            <EyeOff className="h-4 w-4 text-orange-500" />
          )}
          <span className="sr-only">Toggle word count visibility</span>
        </Button>

        {showWordCount && (
          <div className="text-sm text-stone-400 font-medium">Words: {wordCount}</div>
        )}
      </div>
    </div>
  );
};